import otel, { Context, Span, SpanOptions, Tracer } from '@opentelemetry/api';
import React, { FC, ReactNode, useEffect, useState } from 'react';
import { useOtelContext, useSpan } from './hooks';
import OtelContextProvider from './OtelContextProvider';

interface Props {
  children: ReactNode;
  name: string;
  options?: SpanOptions;
  tracer: Tracer;
}

function initialContext(parentContext: Context, span: Span | undefined): Context {
  if (!span) {
    return parentContext;
  }
  return otel.trace.setSpan(parentContext, span);
}

const MountSpan: FC<Props> = (props) => {
  const { children, tracer } = props;
  const parentContext = useOtelContext();
  const span = useSpan(tracer, props.name, props.options, parentContext);
  const [context, setContext] = useState(() => initialContext(parentContext, span));

  useEffect(() => {
    if (!span) {
      setContext(parentContext);
    }
  }, [parentContext, span]);

  return <OtelContextProvider context={context}>{children}</OtelContextProvider>;
};

export default MountSpan;
